<div class="home" [routerLink]="['home']">
     <div class="texto">
      
    </div>
    <div class="login">
      <img src="./../../../assets/logo-xtensa.png" />
      <p>Recuperar Contraseña</p>
  
      <div  *ngIf="invalidUser" class="invalidUser">
        El email que ha introducido no existe en nuestra base de datos.
      </div>
      
      <form class="form" [formGroup]="datosUser">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" formControlName="email" required/>
          <mat-error>Campo Obligatorio, por favor introduzca un mail válido</mat-error>
        </mat-form-field>
  
        
        <button class="primary-button" (click)="handleLogin()" [disabled]="datosUser.invalid">
         Enviar correo
        </button>
      </form>
      <p class="registrarte">
        Introduzca el correo electronico con el que se registró para recuperar la contraseña
      </p>
      
    </div>
  </div>
  
